import React from "react";
import { ShowButton, List, DateField } from "@refinedev/mui";
import { useNavigate } from "react-router-dom";
import { InfiniteList } from "components/list/infinity-list";
import { IUser } from "interfaces/user";

export const UserList: React.FC = () => {
  const navigate = useNavigate();

  return (
    <List title="Users List">
      <InfiniteList<IUser>
        endpoint="users/:accepted"
        limit={10}
        queryParams={{ "filter[status]": `ACCEPTED` }}
        isTable={true}
        columns={[
          {
            header: "First Name",
            field: "firstName",
            sortable: true,
            sortField: "firstName",
          },
          {
            field: "lastName",
            header: "Last Name",
            sortable: true,
            sortField: "lastName",
          },
          {
            field: "email",
            header: "Email",
            sortable: true,
            sortField: "email",
          },
          {
            field: "status",
            header: "Status",
            sortable: false,
          },
          {
            header: "Created At",
            sortable: true,
            sortField: "createdAt",
            renderCell: function render({ createdAt }) {
              return <DateField value={createdAt} />;
            },
          },
          {
            header: "Actions",
            sortable: false,
            renderCell: function render({ sub }) {
              return (
                <>
                  <ShowButton
                    hideText
                    onClick={() => navigate(`/users/show/${sub}`)}
                  />
                </>
              );
            },
          },
        ]}
        tableProps={{
          stickyHeader: true,
          headerBgColor: "grey.200",
          responsive: true,
        }}
        searchConfig={{
          enabled: true,
          placeholder: "Search user by name..",
          searchField: "searchTerm",
        }}
        emptyMessage={`No User found!`}
      />
    </List>
  );
};
